import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as loginActions from '../../store/modules/loginSlice';
import { bindActionCreators } from 'redux';
import OTPVerificationPanel from './OTPVerificationPanel';
import { showToast } from '../Common/Messages';


const PwChangePanel = (props) => {
    const LoginStates = useSelector((state) => state.login);
    const dispatch = useDispatch();
    const LoginActions = bindActionCreators(loginActions, dispatch);

    const [userInfo, setUserInfo] = useState({
        userId: LoginStates.userId,
        userName: LoginStates.userName,
        userPassword: '',
        newPassword: '',
        newPasswordCheck: '',
        newPwCheck: 'default',
        reNewPwCheck: 'default',
        isVerify: false,
        authCode: "0"
    });

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        let newPassword = userInfo.newPassword;
        let newPasswordCheck = userInfo.newPasswordCheck;

        const upperLetters = /[A-Z]/;
        const lowerLetters = /[a-z]/;
        const number = /[0-9]/;
        const special = /[~!@#$%^&*()_+|<>?:{}]/;

        setUserInfo(prev => { return { ...prev, [name]: value } });   //userInfo값이 업데이트되는 기준은 이벤트가 끝까지 돌고 나서

        if (name === 'newPassword')
            newPassword = value;
        else if (name === 'newPasswordCheck')
            newPasswordCheck = value;

        //새 비밀번호 체크
        if (newPassword.length === 0) {
            newPasswordCheck = '';
            setUserInfo(prev => {
                return {
                    ...prev,
                    newPasswordCheck: '',
                    newPwCheck: 'default'
                }
            });
        }
        else if (newPassword.length >= 7 && upperLetters.test(newPassword) && lowerLetters.test(newPassword) &&
            special.test(newPassword) && number.test(newPassword))
            setUserInfo(prev => { return { ...prev, newPwCheck: 'right' } });
        else
            setUserInfo(prev => { return { ...prev, newPwCheck: 'wrong' } });

        //새 비밀번호 다시 체크
        if (newPasswordCheck.length === 0)
            setUserInfo(prev => { return { ...prev, reNewPwCheck: 'default' } });
        else if (newPasswordCheck === newPassword)
            setUserInfo(prev => { return { ...prev, reNewPwCheck: 'right' } });
        else if (newPasswordCheck !== newPassword)
            setUserInfo(prev => { return { ...prev, reNewPwCheck: 'wrong' } });
    };

    const PwClass = (num) => {
        if (num === 'default')
            return null;
        else if (num === 'wrong')
            return (
                <div className='ico-check wrong'><i className='i-input-wrong' /></div>
            );
        else if (num === 'right')
            return (
                <div className='ico-check'><i className='i-input-ok' /></div>
            );
    };

    const ConditionPw = (num) => {
        if (num === 'default' || num === 'right')
            return null;
        else
            return (
                <div className="pw-msg pwchange-position">비밀번호는 대문자, 소문자, 숫자, 특수문자 조합으로 7자 이상이어야 합니다.</div>
            );
    };

    const ChangePwClass = () => {
        if (userInfo.newPwCheck === 'right' && userInfo.reNewPwCheck === 'right' && userInfo.userPassword !== '')
            return (
                <button onClick={onSubmitPwChange} className='btn-primary'>비밀번호 변경</button>
            );
        else
            return (
                <button onClick={(e) => e.preventDefault()} className='btn-primary btn-dis'>비밀번호 변경</button>
            );
    };

    const onSubmitPwChange = (e) => {
        e.preventDefault();
        const passwordsInfo = {
            userId: encodeURI(userInfo.userId),
            userPassword: encodeURI(userInfo.userPassword),
            newPassword: encodeURI(userInfo.newPassword),
            authCode: userInfo.authCode
        };

        fetch('api/Login/PasswordChange', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(passwordsInfo)
        }).then(async (response) => response.json())
            .then(async (responseData) => {
                if (responseData.status === "Wrong Current Password") {
                    showToast('danger', responseData.message, 3000);
                    setUserInfo(prev => { return { ...prev, currentPassword: '' } });
                }
                else if (responseData.status === "Success Changing Password") {
                    const info = responseData.userInformation;
                    const result = {
                        userId: info !== undefined ? info.userId : '',
                        userName: info !== undefined ? info.userName : '',
                        sessionId: info !== undefined ? info.sessionID : '',
                        logindate: new Date().toISOString().slice(0, 10)
                    };
                    await LoginActions.setResultLogin(result);
                    props.setResult(responseData.status);
                    props.setMessage(responseData.message);
                    props.setPanelType('');
                }
            });
    };

    const AfterCheckAuth = (authCode) => {
        setUserInfo(prev => {
            return {
                ...prev,
                isVerify: true,
                authCode: authCode
            }
        });
    };

    const renderPanel = () => {
        if (userInfo.isVerify) {
            return (
                <div className="login-top">
                    {/* <p className="pw-change-txt">안전한 사용을 위해 비밀번호를 변경해주세요. </p> */}
                    <div className="login-input-wrap">
                        <div className="login-input">
                            <label htmlFor="userID">현재 비밀번호</label>
                            <input
                                type='password'
                                name='userPassword'
                                value={userInfo.userPassword}
                                onChange={e => handleChange(e)}
                                placeholder='현재 비밀번호'
                            />
                        </div>
                        <div className="login-input">
                            <label htmlFor="userID">새 비밀번호</label>
                            <input
                                type='password'
                                name='newPassword'
                                value={userInfo.newPassword}
                                onChange={e => handleChange(e)}
                                placeholder='대문자, 소문자, 숫자, 특수문자 조합으로 7자 이상'
                            />
                            {PwClass(userInfo.newPwCheck)}
                            {ConditionPw(userInfo.newPwCheck)}
                        </div>
                        <div className="login-input">
                            <label htmlFor="userID">새 비밀번호 확인</label>
                            <input
                                type='password'
                                name='newPasswordCheck'
                                value={userInfo.newPasswordCheck}
                                onChange={e => handleChange(e)}
                                placeholder='새 비밀번호 확인'
                            />
                            {PwClass(userInfo.reNewPwCheck)}
                        </div>
                    </div>

                    <div className="btn-wrap">
                        {ChangePwClass()}
                        {/*<button onClick={GoBackLogin} className='btn-back'>로그인화면으로 돌아가기</button>*/}
                    </div>

                    <div className="info-box-kstudio mt32">
                        <p>K Developers의 계정으로 영림원소프트랩의 개발 툴인<br /> K-Studio를 사용할 수 있습니다.</p>
                        <ol>
                            <li>K-Studio는 라이선스를 구매한 고객사에게만 제공되며, 라이선스를 보유하지 않은 사용자는 사용할 수 없습니다.</li>
                            <li>K-Studio로 생성된 모든 산출물은 라이선스를 구매한 고객사 내부에서만 사용이 허용됩니다.</li>
                            <li>K-Studio로 생성한 산출물을 불법적으로 복제, 배포, 판매하는 것은 엄격히 금지됩니다.</li>
                        </ol>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="login-top">
                    <p className="pw-change-txt">비밀번호 유효기간(90일)이 지나 비밀번호 변경이 필요해요.<br />먼저, 본인확인을 위해 이메일 인증을 해주세요.</p>
                    <OTPVerificationPanel buttonTitle={'이메일로 인증번호 받기'} state={userInfo} fnAfterCheckAuth={AfterCheckAuth} />
                </div>
            );
        }
    }

    return (
        <div className="login-wrap pw-change">
            <form className="login-box">
                <h2 className='login-title'>비밀번호 변경</h2>
                {renderPanel()}
            </form>
        </div>
    );
};

export default PwChangePanel;